export class StringWrapper {
    public value: string;
}
